import React from 'react';
import { Style } from '../../Theme';
import { useFela } from '../../index';
/**
 * highlighting function that keeps the case of the replaced text
 * works without dangerouslySetInnerHtml by using additional split on replaced string
 *
 * case: input = al | text = Balea
 * 1) replace by regex and temporary separator "B|al|ea"
 * 2) split by temporary separator ["B", "al", "ea"]
 * 2) combine with input fragment bold B(al)ea
 */

const textStyle: Style = ({ theme }) => ({
  fontFamily: theme.typography.fontFamily.primary.main,
  fontWeight: 400,
  fontSize: theme.typography.fontSize.m.rem,
  lineHeight: theme.typography.lineHeight.m.value,
  color: theme.palette.color2.hex,
  padding: theme.dimension.spacing.xxs.rem,
});

interface HighlightedTextProps {
  dmId: string;
  suggestionText: string;
  inputText: string;
  invertedHighlighting?: boolean;
}

const HighlightedText = ({
  dmId,
  suggestionText,
  inputText,
  invertedHighlighting = false,
}: HighlightedTextProps): JSX.Element => {
  const { css } = useFela();

  if (!inputText || inputText?.length < 2) {
    return (
      <span data-designsystem data-dmid={dmId} className={css(textStyle)}>
        {suggestionText}
      </span>
    );
  }

  // remove regex chars from input -> [ ] \ ' * + ? ( )
  const regex = new RegExp(inputText.replace(/[[\]\\'*+?()]+/g, ''), 'gi');
  const tempSeparator = `|`;
  // reference search text in a case sensitive way with $&
  const replaced = suggestionText.replace(
    regex,
    `${tempSeparator}$&${tempSeparator}`,
  );
  const highlightText = (value: string, inverted: boolean, key: number) =>
    inverted && value.length > 0 ? (
      <b key={`${value}-${key}`}>{value}</b>
    ) : (
      value
    );
  const returnedText = replaced
    .split(tempSeparator)
    .map((fragment, key) =>
      fragment.toLowerCase() === inputText.toLowerCase()
        ? highlightText(fragment, invertedHighlighting, key)
        : highlightText(fragment, !invertedHighlighting, key),
    );

  return (
    <span data-designsystem data-dmid={dmId} className={css(textStyle)}>
      {returnedText}
    </span>
  );
};

export default HighlightedText;
